
// These are needed externally so we put instead in common module to prevent loading session.
export const AUTH_HEADER_ITEM = "zw-authHeader";
export const LOGIN_INFO_ITEM = "zw-loginInfo";
export const SESSION_STATE_ITEM = "zw-sessionState";
export const SESSION_INFO_ITEM = "zw-session";
export const USER_PREF_ITEM = "zw-userPrefs";
